import React from "react";

const USCYPage = () => {
  return (
    <section>
      <p>
        USCY (USD Collateral Yield) — Stablecoin Overview USCY is an
        institutional USD stablecoin backed 1:1 by segregated cash reserves held
        in a Delaware statutory trust and custodied at Northern Trust. Unlike
        traditional stablecoins that pool collateral and retain yield at the
        issuer level, USCY uses a vault-based model that preserves the economic
        rights of institutions that supply collateral. Key Attributes 1:1
        redeemable at par for USD by eligible customers GENIUS-aligned: yield
        attaches to vaults, not tokens Reserves held in trust:
        bankruptcy-remote, client-money classification Issued by Brale, a
        regulated U.S. MSB Operated by USCY Digital Asset LLC, which manages
        onboarding, vault logic, and system integrity Optimised for OES,
        treasury workflows, and market-making Economic Model Each mint creates a
        new vault. Yield accrues to that vault until it reaches the front of the
        redemption queue. USCY tokens themselves remain non-yield-bearing.
        Related Concepts Vault Queue Model USCY Reserves Trust Yield Protection
        Points (YPPs) Redemption Process
      </p>
    </section>
  );
};

export default USCYPage;
